import {sweetAPI} from 'app/store/sweet-api';
import {MEDIAACCESS_SECURE_SIGNER_API_URL} from 'app/urls';

const MEDIAACCESS_RTK_TAGS = {
  TAGS: 'mediaaccess',
};

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [MEDIAACCESS_RTK_TAGS.TAGS]})
  .injectEndpoints({
    endpoints: (build) => ({
      signer: build.query<
        {signed_url: string},
        {
          file: string;
        }
      >({
        query: ({file}) => ({
          url: MEDIAACCESS_SECURE_SIGNER_API_URL,
          params: {file},
        }),
      }),
    }),
  });

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {useSignerQuery: useSigner, useLazySignerQuery: useLazySigner} =
  extendedAPI;
